module.exports = __webpack_public_path__ + "public/images/survey/preview.3d38b1d9f97234992a115e437b6e549e.jpg";